export class PromisedTimeModel {
    ID: string
    Name: string
    Description: string
    BeginTime: string
    EndTime: string
    IsActive:boolean
    public constructor(){
        this.ID=""
    }
}